// GeoContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';
import { AuthContext } from './authContext';

const GeoContext = createContext(null);

export const GeoProvider = ({ children }) => {
    const [drawnFeatures, setDrawnFeatures] = useState([]);
    console.log("drawnFeatures ------>", drawnFeatures);
    const [selectedObraId, setSelectedObraId] = useState(null); // Si quieres cargar features por ID de obra
    const { token } = useContext(AuthContext);
    // Handler que MapView llamará para actualizar las features
    //const handleFeaturesUpdate = useCallback((features) => {
    //    setDrawnFeatures(features);
    //}, []);

    const handleFeaturesUpdate = useCallback((newFeatureDataItem) => {
        setDrawnFeatures(prevFeatures => {
            // prevFeatures es SIEMPRE el estado más reciente de drawnFeatures
            return [...prevFeatures, newFeatureDataItem];
        });
    }, []);

    // *** NUEVA FUNCIÓN PARA ELIMINAR UNA FEATURE ***
    const deleteFeature = useCallback((featureIdToDelete) => {
        setDrawnFeatures(prevFeatures => {
            // Filtra el array, manteniendo solo las features cuyo ID no coincide con el ID a eliminar
            const updatedFeatures = prevFeatures.filter(feature => feature.id !== featureIdToDelete);
            return updatedFeatures;
        });
    }, []); // No hay dependencias porque prevFeatures se pasa como argumento de la función de callback


    // Handler para cuando necesitas cargar features existentes (ej. al editar)
    const loadFeaturesForObra = useCallback(async (obraId) => {
        setSelectedObraId(obraId); // Puedes guardar el ID de la obra activa
        try {
            const response = await fetch(`/api/obras/${obraId}/geometries`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) {
                throw new Error('Error al cargar las geometrías existentes.');
            }
            const existingGeometries = await response.json();
            const formattedFeatures = existingGeometries.map(geo => ({
                id: geo.id,
                wkt: geo.wkt,
                feature: null,
                ol_uid: null
            }));
            setDrawnFeatures(formattedFeatures);
        } catch (error) {
            console.error('Error al cargar geometrías para obra:', error);
            setDrawnFeatures([]); // Limpia si hay un error
        }
    }, [token]);

    // Handler para limpiar las features (ej. al crear una nueva obra)
    const clearFeatures = useCallback(() => {
        setDrawnFeatures([]);
        setSelectedObraId(null);
    }, []);

    const value = {
        drawnFeatures,
        handleFeaturesUpdate,
        loadFeaturesForObra,
        clearFeatures,
        selectedObraId,
        deleteFeature
    };

    return <GeoContext.Provider value={value}>{children}</GeoContext.Provider>;
};

export const useGeo = () => {
    const context = useContext(GeoContext);
    if (context === undefined) {
        throw new Error('useGeo must be used within a GeoProvider');
    }
    return context;
};